import Dexie, { type EntityTable } from 'dexie';
import type { ExhibitorContext, PendingScan } from './models';

/**
 * A single Dexie database instance for the whole app. Schema versioning
 * follows Dexie's standard pattern (db.version(N).stores({...})) so future
 * migrations (e.g. Stage 11 admin offline caching) can be added as new
 * .version() calls without disturbing existing installed clients' data.
 */
class LeadCaptureDatabase extends Dexie {
  pendingScans!: EntityTable<PendingScan, 'localId'>;
  exhibitorContext!: EntityTable<ExhibitorContext, 'key'>;

  constructor() {
    super('LeadCaptureDb');

    this.version(1).stores({
      // Indexes (after the primary key): `uploaded` -- the sync engine's
      // core query is "give me everything not yet uploaded"; `scannedAtUtc`
      // -- dashboard "today's scans" and chronological lead ordering;
      // `exhibitorId` -- supports multi-exhibitor-login-history-on-one-device
      // scenarios (e.g. a shared floor tablet) without a full table scan.
      // `uploaded` is deliberately NOT indexed: boolean indexing behaves
      // inconsistently across IndexedDB implementations (some coerce to
      // 0/1, some don't), and this table realistically holds a few hundred
      // to a few thousand rows per event -- a full-table filter scan for
      // "pending" queries is imperceptibly fast at that size and avoids the
      // ambiguity entirely.
      pendingScans: 'localId, scannedAtUtc, exhibitorId',
      exhibitorContext: 'key'
    });
  }
}

export const db = new LeadCaptureDatabase();
